import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
] as const;

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage ?? 'en';
  return (
    <div className="flex items-center gap-1 text-xs" aria-label={t('common.language')}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => void i18n.changeLanguage(l.code)}
          className={`rounded px-2 py-1 ${
            current.startsWith(l.code)
              ? 'bg-brand-50 font-semibold text-brand-700'
              : 'text-slate-600 hover:bg-slate-100'
          }`}
          aria-pressed={current.startsWith(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
